import React, { memo } from 'react';
import { withRouter } from 'react-router-dom';
import Version from './subComponents/Version';
// import LoggedUser from "./subComponents/LoggedUser";
import TokenRefresh from '../../../auth/components/TokenRefresh';
import ChangeTheme from './subComponents/ChangeTheme';

const Body = withRouter(({ children, history }) => {
    return (
        <>
            <Version history={history} />
            {/* <LoggedUser history={history} /> */}
            <TokenRefresh />
            <ChangeTheme />
            {children}
        </>
    );
});

export default memo(Body);
